import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from 'hooks/lang';

import { Notification } from 'entities';

import { Column, overlayEscape, Tag } from 'components/Blocks';

import { useOnScreen } from 'hooks/isOnScreen';
import { NotificationIcon, useNotification } from 'providers/Notifications';

import { getTimePassed } from 'utils/date';

interface SingleNotificationProps {
  children?: never;
  notification: Notification;
}

const FIVE_SECONDS_IN_MS = 5000;

export function SingleNotification({ notification }: SingleNotificationProps) {
  const { markNotificationAsRead } = useNotification();

  const { t } = useLang();

  const { title, timestamp, read, link, type } = notification;

  const [isVisible, setRef] = useOnScreen<HTMLAnchorElement>();

  useEffect(() => {
    if (!isVisible || read) return;

    // To give 'new' badge proper time to be seen
    setTimeout(() => markNotificationAsRead(notification), FIVE_SECONDS_IN_MS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <Link
      className="flex gap-3 rounded-md p-2 transition-colors hover:bg-hover"
      ref={read ? undefined : setRef}
      to={link}
      onClick={() => overlayEscape()}
    >
      <Column gap="1" alignItems="center" className={read ? 'mt-1' : ''}>
        {!read && <Tag color="primary" name={t('new')} size="tiny" />}

        <NotificationIcon size={24} type={type} className="self-center" color="primary-dark" />
      </Column>

      <Column gap="1" className="text-start text-sm">
        <span>{title}</span>

        <strong className="text-xs font-medium text-primary">{getTimePassed(timestamp)}</strong>
      </Column>
    </Link>
  );
}
